(function () {
  function parseJSON(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function asNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function normalizeCsv(items) {
    return (items || [])
      .map(function (item) {
        return String(item).trim();
      })
      .filter(Boolean);
  }

  function normalizeTypeList(csv) {
    return String(csv || "")
      .split(",")
      .map(function (value) {
        return value.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function normalizeLineList(value) {
    return String(value || "")
      .split("\n")
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);
  }

  function moneyFromNumber(amount, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(Math.round(amount * 100), moneyFormat);
    }
    return "$" + amount.toFixed(2);
  }

  function emitAnalyticsEvent(root, name, payload) {
    var enabled = root.dataset.enableAnalytics === "true";
    if (!enabled) {
      return;
    }

    var detail = payload || {};
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: name,
        ringBuilder: detail
      });
    }
  }

  function buildMap(items) {
    return items.reduce(function (acc, item) {
      acc[item.key] = item;
      return acc;
    }, {});
  }

  function toMoneyFromCents(cents, currencyCode) {
    var amount = Number(cents || 0) / 100;
    var code = currencyCode || "USD";
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: code
      }).format(amount);
    } catch (error) {
      return "$" + amount.toFixed(2);
    }
  }

  function debounce(fn, delayMs) {
    var timeout = null;
    return function () {
      var args = arguments;
      window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        fn.apply(null, args);
      }, delayMs);
    };
  }

  var RING_METAL_PALETTE = {
    "yellow-gold": { band: "#d4af37", shadow: "#9c7d24", highlight: "#f1d97a" },
    "gold":        { band: "#d4af37", shadow: "#9c7d24", highlight: "#f1d97a" },
    "rose-gold":   { band: "#c98a82", shadow: "#8a544e", highlight: "#e9b8b0" },
    "rose":        { band: "#c98a82", shadow: "#8a544e", highlight: "#e9b8b0" },
    "white-gold":  { band: "#e3e3e6", shadow: "#a8a8ad", highlight: "#ffffff" },
    "platinum":    { band: "#dcdde0", shadow: "#a0a1a4", highlight: "#f6f6f7" },
    "silver":      { band: "#cdced2", shadow: "#9a9b9f", highlight: "#ededee" }
  };

  function ringStonePath(shape, cx, cy) {
    var s = String(shape || "round").toLowerCase();
    if (s === "oval") {
      return "<ellipse cx='" + cx + "' cy='" + cy + "' rx='70' ry='100'/>";
    }
    if (s === "princess") {
      return "<path d='M " + cx + " " + (cy - 100) + " L " + (cx + 100) + " " + cy + " L " + cx + " " + (cy + 100) + " L " + (cx - 100) + " " + cy + " Z'/>";
    }
    if (s === "emerald" || s === "emerald-cut" || s === "radiant") {
      return "<path d='M " + (cx - 60) + " " + (cy - 100) + " L " + (cx + 60) + " " + (cy - 100) +
        " L " + (cx + 80) + " " + (cy - 80) + " L " + (cx + 80) + " " + (cy + 80) +
        " L " + (cx + 60) + " " + (cy + 100) + " L " + (cx - 60) + " " + (cy + 100) +
        " L " + (cx - 80) + " " + (cy + 80) + " L " + (cx - 80) + " " + (cy - 80) + " Z'/>";
    }
    if (s === "asscher") {
      return "<path d='M " + (cx - 50) + " " + (cy - 90) + " L " + (cx + 50) + " " + (cy - 90) +
        " L " + (cx + 90) + " " + (cy - 50) + " L " + (cx + 90) + " " + (cy + 50) +
        " L " + (cx + 50) + " " + (cy + 90) + " L " + (cx - 50) + " " + (cy + 90) +
        " L " + (cx - 90) + " " + (cy + 50) + " L " + (cx - 90) + " " + (cy - 50) + " Z'/>";
    }
    if (s === "pear") {
      return "<path d='M " + cx + " " + (cy - 110) +
        " Q " + (cx + 80) + " " + (cy - 30) + " " + (cx + 60) + " " + (cy + 60) +
        " Q " + (cx + 40) + " " + (cy + 110) + " " + cx + " " + (cy + 110) +
        " Q " + (cx - 40) + " " + (cy + 110) + " " + (cx - 60) + " " + (cy + 60) +
        " Q " + (cx - 80) + " " + (cy - 30) + " " + cx + " " + (cy - 110) + " Z'/>";
    }
    if (s === "marquise") {
      return "<path d='M " + cx + " " + (cy - 120) +
        " Q " + (cx + 80) + " " + cy + " " + cx + " " + (cy + 120) +
        " Q " + (cx - 80) + " " + cy + " " + cx + " " + (cy - 120) + " Z'/>";
    }
    if (s === "cushion") {
      return "<rect x='" + (cx - 85) + "' y='" + (cy - 85) + "' width='170' height='170' rx='40' ry='40'/>";
    }
    if (s === "heart") {
      return "<path d='M " + cx + " " + (cy + 95) +
        " C " + (cx - 90) + " " + (cy + 30) + ", " + (cx - 100) + " " + (cy - 50) + ", " + (cx - 40) + " " + (cy - 80) +
        " C " + (cx - 15) + " " + (cy - 92) + ", " + cx + " " + (cy - 70) + ", " + cx + " " + (cy - 40) +
        " C " + cx + " " + (cy - 70) + ", " + (cx + 15) + " " + (cy - 92) + ", " + (cx + 40) + " " + (cy - 80) +
        " C " + (cx + 100) + " " + (cy - 50) + ", " + (cx + 90) + " " + (cy + 30) + ", " + cx + " " + (cy + 95) + " Z'/>";
    }
    if (s === "baguette") {
      return "<rect x='" + (cx - 45) + "' y='" + (cy - 90) + "' width='90' height='180' rx='4'/>";
    }
    return "<circle cx='" + cx + "' cy='" + cy + "' r='85'/>";
  }

  function ringSettingDecoration(setting, metal, cx, cy) {
    var s = String(setting || "solitaire").toLowerCase();
    var parts = [];
    if (s === "halo") {
      var haloRadius = 130;
      for (var i = 0; i < 18; i += 1) {
        var angle = (i / 18) * Math.PI * 2;
        var hx = cx + Math.cos(angle) * haloRadius;
        var hy = cy + Math.sin(angle) * haloRadius;
        parts.push("<circle cx='" + hx.toFixed(1) + "' cy='" + hy.toFixed(1) + "' r='14' fill='#ffffff' stroke='" + metal.shadow + "' stroke-width='1.5'/>");
      }
    } else if (s === "three-stone" || s === "trilogy") {
      parts.push("<circle cx='" + (cx - 150) + "' cy='" + cy + "' r='55' fill='#ffffff' stroke='" + metal.shadow + "' stroke-width='2'/>");
      parts.push("<circle cx='" + (cx + 150) + "' cy='" + cy + "' r='55' fill='#ffffff' stroke='" + metal.shadow + "' stroke-width='2'/>");
    } else if (s === "bezel") {
      parts.push("<circle cx='" + cx + "' cy='" + cy + "' r='115' fill='none' stroke='" + metal.band + "' stroke-width='22'/>");
    } else if (s === "pave") {
      for (var p = 0; p < 14; p += 1) {
        var pa = Math.PI + (p / 13) * Math.PI;
        var px = 400 + Math.cos(pa) * 235;
        var py = 540 + Math.sin(pa) * 78;
        parts.push("<circle cx='" + px.toFixed(1) + "' cy='" + py.toFixed(1) + "' r='6' fill='#ffffff' stroke='" + metal.shadow + "' stroke-width='1'/>");
      }
    } else if (s === "channel") {
      parts.push("<path d='M 180 540 A 220 60 0 0 1 620 540' fill='none' stroke='" + metal.shadow + "' stroke-width='3'/>");
      for (var c = 0; c < 9; c += 1) {
        var ca = Math.PI + ((c + 0.5) / 9) * Math.PI;
        var cxp = 400 + Math.cos(ca) * 220;
        var cyp = 540 + Math.sin(ca) * 60;
        parts.push("<rect x='" + (cxp - 10).toFixed(1) + "' y='" + (cyp - 10).toFixed(1) + "' width='20' height='20' fill='#ffffff' stroke='" + metal.shadow + "' stroke-width='1'/>");
      }
    } else if (s === "cathedral") {
      parts.push("<path d='M 280 520 Q 360 380 " + cx + " " + (cy + 80) + "' fill='none' stroke='" + metal.band + "' stroke-width='22' stroke-linecap='round'/>");
      parts.push("<path d='M 520 520 Q 440 380 " + cx + " " + (cy + 80) + "' fill='none' stroke='" + metal.band + "' stroke-width='22' stroke-linecap='round'/>");
    }
    // Prongs around center stone (skip when bezel)
    if (s !== "bezel" && s !== "tension") {
      [[-65, -65], [65, -65], [-65, 65], [65, 65]].forEach(function (offset) {
        parts.push("<circle cx='" + (cx + offset[0]) + "' cy='" + (cy + offset[1]) + "' r='9' fill='" + metal.band + "' stroke='" + metal.shadow + "' stroke-width='1'/>");
      });
    }
    return parts.join("");
  }

  function buildRingSvg(opts) {
    var safe = opts || {};
    var metal = RING_METAL_PALETTE[String(safe.metal || "yellow-gold").toLowerCase()] || RING_METAL_PALETTE["yellow-gold"];
    var cx = 400;
    var cy = 320;
    var stonePath = ringStonePath(safe.shape, cx, cy);
    var decoration = ringSettingDecoration(safe.setting, metal, cx, cy);

    var svg =
      "<svg xmlns='http://www.w3.org/2000/svg' width='800' height='800' viewBox='0 0 800 800'>" +
        "<defs>" +
          "<linearGradient id='rb-band' x1='0' y1='0' x2='0' y2='1'>" +
            "<stop offset='0%' stop-color='" + metal.highlight + "'/>" +
            "<stop offset='55%' stop-color='" + metal.band + "'/>" +
            "<stop offset='100%' stop-color='" + metal.shadow + "'/>" +
          "</linearGradient>" +
          "<radialGradient id='rb-stone' cx='40%' cy='35%' r='65%'>" +
            "<stop offset='0%' stop-color='#ffffff' stop-opacity='1'/>" +
            "<stop offset='70%' stop-color='#eef1f5' stop-opacity='1'/>" +
            "<stop offset='100%' stop-color='#bcc2cc' stop-opacity='1'/>" +
          "</radialGradient>" +
        "</defs>" +
        "<rect width='800' height='800' fill='#ffffff'/>" +
        // Band back arc (shadow side)
        "<ellipse cx='400' cy='540' rx='240' ry='80' fill='none' stroke='" + metal.shadow + "' stroke-width='44'/>" +
        // Band front arc (lit side)
        "<path d='M 160 540 A 240 80 0 0 0 640 540' fill='none' stroke='url(#rb-band)' stroke-width='44' stroke-linecap='round'/>" +
        // Soft contact shadow under stone
        "<ellipse cx='400' cy='" + (cy + 130) + "' rx='95' ry='14' fill='rgba(0,0,0,0.08)'/>" +
        // Setting-specific decoration drawn behind stone
        decoration +
        // Center stone
        "<g fill='url(#rb-stone)' stroke='#9aa1ac' stroke-width='1.5'>" + stonePath + "</g>" +
        // Stone highlight
        "<ellipse cx='" + (cx - 25) + "' cy='" + (cy - 30) + "' rx='18' ry='8' fill='rgba(255,255,255,0.85)' transform='rotate(-25 " + (cx - 25) + " " + (cy - 30) + ")'/>" +
      "</svg>";

    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function detectRingTraitsFromText(text) {
    var t = String(text || "").toLowerCase();
    var metal = "yellow-gold";
    if (t.indexOf("rose") > -1) metal = "rose-gold";
    else if (t.indexOf("white gold") > -1) metal = "white-gold";
    else if (t.indexOf("platinum") > -1) metal = "platinum";
    else if (t.indexOf("silver") > -1) metal = "silver";

    var shape = "round";
    ["oval", "princess", "emerald", "asscher", "pear", "marquise", "cushion", "heart", "radiant", "baguette"].some(function (s) {
      if (t.indexOf(s) > -1) { shape = s; return true; }
      return false;
    });

    var setting = "solitaire";
    ["halo", "three-stone", "trilogy", "pave", "channel", "bezel", "tension", "cathedral"].some(function (s) {
      if (t.indexOf(s.replace("-", " ")) > -1 || t.indexOf(s) > -1) { setting = s; return true; }
      return false;
    });

    return { setting: setting, metal: metal, shape: shape };
  }

  function buildSuggestEndpoint(query, limit) {
    var params = new URLSearchParams();
    params.set("q", query || "");
    params.set("resources[type]", "product");
    params.set("resources[limit]", String(limit || 1));
    params.set("resources[options][unavailable_products]", "hide");
    return "/search/suggest.json?" + params.toString();
  }

  function initLiveStudio(root) {
    var input = root.querySelector("[data-ring-live-input]");
    var output = root.querySelector("[data-ring-live-output]");
    var tagsNode = root.querySelector("[data-ring-live-tags]");
    var windowNode = root.querySelector("[data-ring-live-window]");
    var imageNode = root.querySelector("[data-ring-live-image]");
    var suggestionNode = root.querySelector("[data-ring-live-suggestion]");
    var suggestionTextNode = root.querySelector("[data-ring-live-suggestion-text]");
    var suggestionLink = root.querySelector("[data-ring-live-suggestion-link]");
    var suggestionClose = root.querySelector("[data-ring-live-suggestion-close]");
    if (!input || !output || !tagsNode || !windowNode || !imageNode) {
      return;
    }
    var similarityThreshold = Math.max(1, Math.min(100, asNumber(root.dataset.similarityThreshold) || 70));
    var liveAiDebounceMs = Math.max(300, Math.min(5000, asNumber(root.dataset.liveAiDebounceMs) || 900));
    var AI_RENDER_DELAY_MS = 2000;
    var PLACEHOLDER_OUTPUT_TEXT = "Your concept will start rendering after the request is fully entered.";
    var aiImageEnabled = root.dataset.aiImageEnabled === "true";
    var aiImageBaseUrl = String(root.dataset.aiImageBaseUrl || "").trim();
    var aiImageMode = String(root.dataset.aiImageMode || "direct").trim();
    var aiWorkerUrlRaw = String(root.dataset.aiWorkerUrl || "").trim().replace(/\/+$/, "");
    var aiWorkerUrl = /example\.workers\.dev$/i.test(aiWorkerUrlRaw) ? "" : aiWorkerUrlRaw;
    var workerFetchController = null;

    var meshyEnabled = root.dataset.meshy3dEnabled === "true" && !!aiWorkerUrl;
    var modelContainer = root.querySelector("[data-ring-live-model]");
    var modelStatusNode = root.querySelector("[data-ring-live-model-status]");
    var modelStatusText = root.querySelector("[data-ring-live-model-status-text]");
    var modelToggleButton = root.querySelector("[data-ring-live-model-toggle]");
    var meshyPollTimer = null;
    var meshyShowingModel = false;
    // Once a 3D model loads we cache it by image URL so re-rendering the same
    // concept (e.g. typing again with the same text) doesn't spend another
    // Meshy credit.
    var meshyCache = {};

    var selectedFilters = { metal: "", shape: "" };
    var chipGroupNodes = root.querySelectorAll("[data-ring-live-chip-group]");
    var filterStatusNode = root.querySelector("[data-ring-live-filter-status]");
    var filterListNode = root.querySelector("[data-ring-live-filter-list]");
    var filterResultsNode = root.querySelector("[data-ring-live-filter-results]");
    var filterResetButton = root.querySelector("[data-ring-live-filter-reset]");
    var filterController = null;

    function chipLabel(group, value) {
      var btn = root.querySelector("[data-ring-live-chip-group='" + group + "'] button[data-chip-value='" + value + "']");
      if (!btn) return value;
      return (btn.getAttribute("data-chip-label") || btn.getAttribute("aria-label") || btn.textContent || value).trim();
    }

    function getActiveTraits() {
      var detected = detectRingTraitsFromText(input.value);
      return {
        setting: detected.setting,
        metal: selectedFilters.metal || detected.metal,
        shape: selectedFilters.shape || detected.shape
      };
    }

    function getAugmentedQuery() {
      var parts = [(input.value || "").trim()];
      if (selectedFilters.metal) parts.push(chipLabel("metal", selectedFilters.metal));
      if (selectedFilters.shape) parts.push(chipLabel("shape", selectedFilters.shape) + " cut");
      return parts.filter(Boolean).join(" ");
    }

    var keywordGroups = [
      { mood: "modern", words: ["modern", "minimal", "sleek", "clean", "contemporary"] },
      { mood: "hiphop", words: ["hip hop", "iced", "iced-out", "cuban", "statement", "bustdown", "pave"] },
      { mood: "highend", words: ["luxury", "high-end", "high end", "couture", "premium", "bespoke"] }
    ];

    var tagDictionary = [
      "ring",
      "necklace",
      "pendant",
      "bracelet",
      "earring",
      "gold",
      "white gold",
      "rose gold",
      "platinum",
      "silver",
      "diamond",
      "emerald",
      "ruby",
      "sapphire",
      "oval",
      "round",
      "princess",
      "emerald cut",
      "vintage",
      "minimal",
      "hip hop",
      "high-end"
    ];
    var requestController = null;
    var suggestionController = null;
    var liveRenderVersion = 0;

    function detectMood(text) {
      var normalized = text.toLowerCase();
      var selected = "modern";
      keywordGroups.some(function (group) {
        var found = group.words.some(function (word) {
          return normalized.indexOf(word) > -1;
        });
        if (found) {
          selected = group.mood;
        }
        return found;
      });
      return selected;
    }

    function buildTags(text) {
      var normalized = text.toLowerCase();
      return tagDictionary.filter(function (tag) {
        return normalized.indexOf(tag) > -1;
      }).slice(0, 6);
    }

    function render(text) {
      var trimmed = text.trim();
      var hasInput = trimmed.length > 0;
      var mood = detectMood(trimmed);
      var tags = buildTags(trimmed);

      windowNode.dataset.mood = mood;
      output.textContent = hasInput
        ? "Rendering: " + trimmed
        : PLACEHOLDER_OUTPUT_TEXT;

      tagsNode.innerHTML = "";
      if (!tags.length && hasInput) {
        tags = ["custom", mood];
      }
      tags.forEach(function (tag) {
        var node = document.createElement("span");
        node.textContent = tag;
        tagsNode.appendChild(node);
      });

      var gemNode = windowNode.querySelector(".ring-builder-live__gem");
      if (gemNode) {
        var intensity = Math.min(18, Math.max(0, Math.floor(trimmed.length / 12)));
        gemNode.style.transform = "rotate(45deg) scale(" + (1 + intensity / 100) + ")";
      }
    }

    function getImageUrlFromProduct(product) {
      if (!product) {
        return "";
      }
      if (product.featured_image && product.featured_image.url) {
        return product.featured_image.url;
      }
      if (typeof product.image === "string" && product.image) {
        return product.image;
      }
      if (product.image && product.image.url) {
        return product.image.url;
      }
      if (Array.isArray(product.images) && product.images.length && product.images[0].url) {
        return product.images[0].url;
      }
      return "";
    }

    function isLikelyHeic(url) {
      return /\.heic(\?|$)/i.test(String(url || ""));
    }

    function chooseBestImageProduct(products) {
      var best = null;
      var fallback = null;
      products.forEach(function (product) {
        var url = getImageUrlFromProduct(product);
        if (!url) {
          return;
        }
        if (!fallback) {
          fallback = { product: product, url: url };
        }
        if (!isLikelyHeic(url) && !best) {
          best = { product: product, url: url };
        }
      });
      return best || fallback;
    }

    function renderGeneratedFallback(query, mood) {
      imageNode.src = buildRingSvg(getActiveTraits());
      imageNode.alt = "Ring concept preview";
      imageNode.hidden = false;
    }

    function buildAiImageUrl(query) {
      if (!aiImageEnabled || !aiImageBaseUrl) {
        return "";
      }
      var styledPrompt;
      var intermediary = window.JewelryPromptIntermediary;
      if (intermediary && typeof intermediary.process === "function") {
        try {
          var processed = intermediary.process(query);
          styledPrompt = processed.prompt;
          if (root.dataset.debugIntermediary === "true" && window.console) {
            window.console.log("[JewelryIntermediary] spec:", processed.spec);
            window.console.log("[JewelryIntermediary] prompt:", processed.prompt);
          }
        } catch (error) {
          styledPrompt = null;
        }
      }
      if (!styledPrompt) {
        styledPrompt =
          "premium ecommerce jewelry product photo, isolated piece only, plain white background, no props, no hands, no scene, clean studio lighting, centered composition: " +
          query;
      }
      var params = new URLSearchParams();
      params.set("width", "1024");
      params.set("height", "1024");
      params.set("nologo", "true");
      params.set("seed", String(Math.abs(hashCode(query)).toString().slice(0, 7) || "9831"));
      params.set("safe", "true");
      var separator = aiImageBaseUrl.indexOf("?") > -1 ? "&" : "?";
      return aiImageBaseUrl.replace(/\/+$/, "/") + encodeURIComponent(styledPrompt) + separator + params.toString();
    }

    function hashCode(value) {
      var hash = 0;
      for (var i = 0; i < value.length; i += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash |= 0;
      }
      return hash;
    }

    function tokenize(text) {
      return String(text || "")
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, " ")
        .split(/\s+/)
        .filter(function (token) {
          return token && token.length > 2;
        });
    }

    function similarityScore(query, candidate) {
      var queryTokens = tokenize(query);
      if (!queryTokens.length) {
        return 0;
      }
      var candidateTokens = tokenize(candidate);
      if (!candidateTokens.length) {
        return 0;
      }
      var lookup = {};
      candidateTokens.forEach(function (token) {
        lookup[token] = true;
      });
      var matches = 0;
      queryTokens.forEach(function (token) {
        if (lookup[token]) {
          matches += 1;
        }
      });
      return Math.round((matches / queryTokens.length) * 100);
    }

    function hideSuggestionPopup() {
      if (suggestionNode) {
        suggestionNode.hidden = true;
      }
    }

    function showSuggestionPopup(product, score) {
      if (!suggestionNode || !suggestionTextNode || !suggestionLink) {
        return;
      }
      suggestionTextNode.textContent =
        "We found a " + score + "% similar piece in stock: " + (product.title || "View product") + ".";
      suggestionLink.href = product.url || "#";
      suggestionNode.hidden = false;
    }

    function showLoadingState() {
      if (windowNode) {
        windowNode.dataset.loading = "true";
      }
      output.textContent = "Generating concept... this can take 10-30 seconds.";
    }

    function clearLoadingState() {
      if (windowNode) {
        windowNode.dataset.loading = "false";
      }
    }

    function buildPrecisionPrompt(rawText) {
      var intermediary = window.JewelryPromptIntermediary;
      if (intermediary && typeof intermediary.process === "function") {
        try {
          var processed = intermediary.process(rawText);
          if (root.dataset.debugIntermediary === "true" && window.console) {
            window.console.log("[JewelryIntermediary] spec:", processed.spec);
            window.console.log("[JewelryIntermediary] prompt:", processed.prompt);
          }
          return processed.prompt;
        } catch (_) {
          /* fall through to raw text */
        }
      }
      return (
        "premium ecommerce jewelry product photo, isolated piece only, plain white background, no props, no hands, no scene, clean studio lighting, centered composition: " +
        rawText
      );
    }

    function fetchFromWorker(precisionPrompt, query) {
      if (workerFetchController) {
        workerFetchController.abort();
      }
      workerFetchController = new AbortController();

      var seed = String(Math.abs(hashCode(query)));
      var endpoint = aiWorkerUrl + "/generate";

      return fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ prompt: precisionPrompt, seed: seed }),
        signal: workerFetchController.signal,
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Worker returned " + response.status);
          }
          return response.json();
        })
        .then(function (payload) {
          if (!payload || !payload.url) {
            throw new Error("Worker returned no image URL");
          }
          return payload.url;
        });
    }

    function renderGeneratedImage(query, mood) {
      var trimmed = query.trim();
      var typed = (input.value || "").trim();
      if (!trimmed || !typed) {
        liveRenderVersion += 1;
        clearLoadingState();
        hideSuggestionPopup();
        hideMeshyUi();
        imageNode.hidden = true;
        imageNode.removeAttribute("src");
        imageNode.alt = "";
        output.textContent = PLACEHOLDER_OUTPUT_TEXT;
        return;
      }

      if (!aiImageEnabled) {
        renderGeneratedFallback(trimmed, mood);
        return;
      }

      liveRenderVersion += 1;
      var versionAtRequest = liveRenderVersion;
      var timedOut = false;
      var settled = false;
      var timeoutId = null;

      imageNode.alt = "Generating jewelry concept";
      showLoadingState();

      function finalizeWithFallback() {
        if (settled || versionAtRequest !== liveRenderVersion) {
          return;
        }
        settled = true;
        window.clearTimeout(timeoutId);
        clearLoadingState();
        renderGeneratedFallback(trimmed, mood);
        output.textContent = "Rendered from live concept model.";
      }

      function finalizeWithImage(src) {
        if (settled || versionAtRequest !== liveRenderVersion) {
          return;
        }
        var loader = new window.Image();
        loader.onload = function () {
          if (settled || versionAtRequest !== liveRenderVersion) {
            return;
          }
          settled = true;
          window.clearTimeout(timeoutId);
          clearLoadingState();
          imageNode.src = src;
          imageNode.alt = "AI generated jewelry concept";
          imageNode.hidden = false;
          output.textContent = "Rendered from live concept model.";
          if (meshyEnabled) {
            kickoffMeshy(src, versionAtRequest);
          }
        };
        loader.onerror = finalizeWithFallback;
        loader.src = src;
      }

      timeoutId = window.setTimeout(function () {
        timedOut = true;
        finalizeWithFallback();
      }, 60000);

      var precisionPrompt = buildPrecisionPrompt(trimmed);
      var useWorker = aiImageMode === "worker" && aiWorkerUrl;

      if (useWorker) {
        fetchFromWorker(precisionPrompt, trimmed)
          .then(function (imageUrl) {
            if (timedOut) {
              return;
            }
            finalizeWithImage(imageUrl);
          })
          .catch(function (err) {
            if (err && err.name === "AbortError") {
              return;
            }
            // Worker failed — try direct URL fallback before giving up
            var directUrl = buildAiImageUrl(trimmed);
            if (directUrl) {
              var cacheBusted = directUrl + (directUrl.indexOf("?") > -1 ? "&" : "?") + "cb=" + Date.now();
              finalizeWithImage(cacheBusted);
            } else {
              finalizeWithFallback();
            }
          });
        return;
      }

      var aiUrl = buildAiImageUrl(trimmed);
      if (!aiUrl) {
        finalizeWithFallback();
        return;
      }
      var requestUrl = aiUrl + (aiUrl.indexOf("?") > -1 ? "&" : "?") + "cb=" + Date.now();
      finalizeWithImage(requestUrl);
    }

    function checkSimilarityPopup(query) {
      var trimmed = query.trim();
      if (!trimmed) {
        hideSuggestionPopup();
        return;
      }
      if (suggestionController) {
        suggestionController.abort();
      }
      suggestionController = new AbortController();
      fetch(buildSuggestEndpoint(trimmed, 8), {
        method: "GET",
        headers: { Accept: "application/json" },
        signal: suggestionController.signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Suggest API failed");
          }
          return response.json();
        })
        .then(function (payload) {
          var products = (((payload || {}).resources || {}).results || {}).products || [];
          var best = null;
          products.forEach(function (product) {
            var candidateText = [product.title || "", product.body || "", product.type || "", (product.tags || []).join(" ")].join(" ");
            var score = similarityScore(trimmed, candidateText);
            if (!best || score > best.score) {
              best = { product: product, score: score };
            }
          });
          if (best && best.score >= similarityThreshold) {
            showSuggestionPopup(best.product, best.score);
          } else {
            hideSuggestionPopup();
          }
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") {
            return;
          }
          hideSuggestionPopup();
        });
    }

    function renderFilterResults(products) {
      if (!filterListNode) return;
      filterListNode.innerHTML = "";
      products.forEach(function (product) {
        var li = document.createElement("li");
        var link = document.createElement("a");
        link.href = product.url || "#";

        var thumb = document.createElement("img");
        var raw = getImageUrlFromProduct(product);
        thumb.src = raw || buildRingSvg(getActiveTraits());
        thumb.alt = "";
        thumb.loading = "lazy";
        thumb.onerror = function () {
          thumb.onerror = null;
          thumb.src = buildRingSvg(getActiveTraits());
        };
        link.appendChild(thumb);

        var meta = document.createElement("div");
        meta.className = "ring-builder-live__filter-meta";

        var titleEl = document.createElement("span");
        titleEl.className = "ring-builder-live__filter-title";
        titleEl.textContent = product.title || "Untitled";
        meta.appendChild(titleEl);

        var subEl = document.createElement("span");
        subEl.className = "ring-builder-live__filter-sub";
        var priceText = "";
        if (typeof product.price === "number" || (product.price && !isNaN(Number(product.price)))) {
          priceText = toMoneyFromCents(product.price, product.price_currency);
        }
        subEl.textContent = [product.product_type || "", priceText].filter(Boolean).join(" — ");
        meta.appendChild(subEl);

        link.appendChild(meta);
        li.appendChild(link);
        filterListNode.appendChild(li);
      });
    }

    function setFilterStatus(message) {
      if (filterStatusNode) filterStatusNode.textContent = message;
    }

    function showFilterPanel(show) {
      if (filterResultsNode) filterResultsNode.hidden = !show;
    }

    function fetchDetailedResults() {
      var query = getAugmentedQuery().trim();
      if (!query) {
        showFilterPanel(false);
        return;
      }
      if (filterController) filterController.abort();
      filterController = new AbortController();
      setFilterStatus("Searching matching pieces...");
      showFilterPanel(true);
      renderFilterResults([]);

      fetch(buildSuggestEndpoint(query, 6), {
        method: "GET",
        headers: { Accept: "application/json" },
        signal: filterController.signal
      })
        .then(function (response) {
          return response.ok ? response.json() : { resources: { results: { products: [] } } };
        })
        .then(function (payload) {
          var products = (((payload || {}).resources || {}).results || {}).products || [];
          var labelParts = [];
          if (selectedFilters.metal) labelParts.push(chipLabel("metal", selectedFilters.metal));
          if (selectedFilters.shape) labelParts.push(chipLabel("shape", selectedFilters.shape));
          var labelSuffix = labelParts.length ? " (" + labelParts.join(", ") + ")" : "";
          if (!products.length) {
            setFilterStatus("No matches yet — try different keywords or fewer filters" + labelSuffix + ".");
            renderFilterResults([]);
            return;
          }
          setFilterStatus(products.length + " match" + (products.length === 1 ? "" : "es") + " from inventory" + labelSuffix + ".");
          renderFilterResults(products);
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") return;
          setFilterStatus("Couldn't load inventory — refine your selections and try again.");
        });
    }

    function clearMeshyPoll() {
      if (meshyPollTimer !== null) {
        window.clearTimeout(meshyPollTimer);
        meshyPollTimer = null;
      }
    }

    function hideMeshyUi() {
      clearMeshyPoll();
      if (modelStatusNode) modelStatusNode.hidden = true;
      if (modelToggleButton) modelToggleButton.hidden = true;
      if (modelContainer) {
        modelContainer.hidden = true;
        modelContainer.innerHTML = "";
      }
      meshyShowingModel = false;
    }

    function setMeshyStatus(text) {
      if (!modelStatusNode || !modelStatusText) return;
      modelStatusNode.hidden = false;
      modelStatusText.textContent = text;
    }

    function showMeshyModel(modelUrl) {
      if (!modelContainer) return;
      modelContainer.innerHTML = "";
      var viewer = document.createElement("model-viewer");
      viewer.setAttribute("src", modelUrl);
      viewer.setAttribute("camera-controls", "");
      viewer.setAttribute("auto-rotate", "");
      viewer.setAttribute("ar", "");
      viewer.setAttribute("shadow-intensity", "1");
      viewer.setAttribute("exposure", "1");
      viewer.setAttribute("alt", "3D view of generated jewelry concept");
      modelContainer.appendChild(viewer);
      modelContainer.hidden = false;
      imageNode.hidden = true;
      meshyShowingModel = true;
      if (modelToggleButton) {
        modelToggleButton.hidden = false;
        modelToggleButton.textContent = "View flat image";
      }
      setMeshyStatus("3D view ready — drag to rotate.");
    }

    function kickoffMeshy(imageUrl, versionAtRequest) {
      if (!meshyEnabled || !imageUrl) return;
      clearMeshyPoll();
      if (modelToggleButton) modelToggleButton.hidden = true;
      if (modelContainer) {
        modelContainer.hidden = true;
        modelContainer.innerHTML = "";
      }
      meshyShowingModel = false;

      if (meshyCache[imageUrl]) {
        showMeshyModel(meshyCache[imageUrl]);
        return;
      }

      setMeshyStatus("Building 3D view…");

      fetch(aiWorkerUrl + "/mesh", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ imageUrl: imageUrl })
      })
        .then(function (response) {
          if (!response.ok) throw new Error("mesh kickoff " + response.status);
          return response.json();
        })
        .then(function (payload) {
          if (versionAtRequest !== liveRenderVersion) return;
          var taskId = payload && payload.taskId;
          if (!taskId) throw new Error("no task id");
          pollMeshy(taskId, imageUrl, versionAtRequest, Date.now());
        })
        .catch(function () {
          if (versionAtRequest !== liveRenderVersion) return;
          if (modelStatusNode) modelStatusNode.hidden = true;
        });
    }

    function pollMeshy(taskId, imageUrl, versionAtRequest, startedAt) {
      var MAX_POLL_MS = 5 * 60 * 1000;
      function tick() {
        if (versionAtRequest !== liveRenderVersion) return;
        if (Date.now() - startedAt > MAX_POLL_MS) {
          setMeshyStatus("3D view took too long — try again later.");
          return;
        }
        fetch(aiWorkerUrl + "/mesh/status?id=" + encodeURIComponent(taskId), {
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("mesh status " + response.status);
            return response.json();
          })
          .then(function (payload) {
            if (versionAtRequest !== liveRenderVersion) return;
            var status = String((payload && payload.status) || "").toUpperCase();
            var progress = Number((payload && payload.progress) || 0);
            if (status === "SUCCEEDED" && payload.modelUrl) {
              meshyCache[imageUrl] = payload.modelUrl;
              showMeshyModel(payload.modelUrl);
              return;
            }
            if (status === "FAILED" || status === "CANCELED") {
              setMeshyStatus("3D view unavailable for this concept.");
              return;
            }
            setMeshyStatus("Building 3D view… " + (progress ? progress + "%" : ""));
            meshyPollTimer = window.setTimeout(tick, 3000);
          })
          .catch(function () {
            if (versionAtRequest !== liveRenderVersion) return;
            meshyPollTimer = window.setTimeout(tick, 5000);
          });
      }
      tick();
    }

    if (modelToggleButton) {
      modelToggleButton.addEventListener("click", function () {
        if (!modelContainer) return;
        if (meshyShowingModel) {
          modelContainer.hidden = true;
          imageNode.hidden = false;
          meshyShowingModel = false;
          modelToggleButton.textContent = "View in 3D";
        } else {
          modelContainer.hidden = false;
          imageNode.hidden = true;
          meshyShowingModel = true;
          modelToggleButton.textContent = "View flat image";
        }
      });
    }

    var debouncedRender = debounce(render, 60);
    var debouncedImage = debounce(function (value) {
      var mood = detectMood(value);
      renderGeneratedImage(value, mood);
      checkSimilarityPopup(value);
    }, AI_RENDER_DELAY_MS);
    var debouncedDetailed = debounce(fetchDetailedResults, Math.max(400, Math.floor(liveAiDebounceMs / 2)));

    function applyAllFromQuery() {
      var augmented = getAugmentedQuery();
      var typed = (input.value || "").trim();
      debouncedRender(augmented);
      debouncedDetailed();
      if (!typed) {
        // Visitor hasn't typed a request yet — cancel any pending image render
        // and keep the placeholder visible.
        liveRenderVersion += 1;
        clearLoadingState();
        hideSuggestionPopup();
        hideMeshyUi();
        imageNode.hidden = true;
        imageNode.removeAttribute("src");
        imageNode.alt = "";
        output.textContent = PLACEHOLDER_OUTPUT_TEXT;
        return;
      }
      debouncedImage(augmented);
    }

    function updateFilterReset() {
      if (filterResetButton) {
        filterResetButton.hidden = !(selectedFilters.metal || selectedFilters.shape);
      }
    }

    Array.prototype.forEach.call(chipGroupNodes, function (groupEl) {
      var group = groupEl.getAttribute("data-ring-live-chip-group");
      groupEl.addEventListener("click", function (event) {
        var btn = event.target.closest && event.target.closest("button[data-chip-value]");
        if (!btn || !groupEl.contains(btn)) return;
        var value = btn.getAttribute("data-chip-value");
        var current = selectedFilters[group];
        Array.prototype.forEach.call(groupEl.querySelectorAll("button[data-chip-value]"), function (b) {
          b.setAttribute("aria-pressed", "false");
        });
        if (current === value) {
          selectedFilters[group] = "";
        } else {
          selectedFilters[group] = value;
          btn.setAttribute("aria-pressed", "true");
        }
        updateFilterReset();
        applyAllFromQuery();
        emitAnalyticsEvent(root, "ring_builder_live_filter_changed", {
          group: group,
          value: selectedFilters[group]
        });
      });
    });

    if (filterResetButton) {
      filterResetButton.addEventListener("click", function () {
        selectedFilters = { metal: "", shape: "" };
        Array.prototype.forEach.call(root.querySelectorAll("[data-ring-live-chip-group] button[data-chip-value]"), function (b) {
          b.setAttribute("aria-pressed", "false");
        });
        updateFilterReset();
        applyAllFromQuery();
      });
    }

    input.addEventListener("input", function () {
      applyAllFromQuery();
    });

    if (suggestionClose) {
      suggestionClose.addEventListener("click", hideSuggestionPopup);
    }

    render(getAugmentedQuery());
    if ((input.value || "").trim()) {
      renderGeneratedImage(getAugmentedQuery(), detectMood(getAugmentedQuery()));
      checkSimilarityPopup(getAugmentedQuery());
    } else {
      imageNode.hidden = true;
      imageNode.removeAttribute("src");
      output.textContent = PLACEHOLDER_OUTPUT_TEXT;
    }
    fetchDetailedResults();
  }

  function initRingBuilder(root) {
    var form = root.querySelector("[data-ring-builder-form]");
    if (!form) {
      return;
    }

    var configTag = root.querySelector("[data-ring-config]");
    var config = parseJSON(configTag ? configTag.textContent : "{}", {
      settings: [],
      metals: [],
      shapes: [],
      carats: []
    });

    var previewImageMap = parseJSON(root.dataset.previewImageMap || "{}", {});
    var basePrice = asNumber(root.dataset.basePrice);
    var engravingFee = asNumber(root.dataset.engravingFee);
    var moneyFormat = root.dataset.moneyFormat || "${{amount}}";
    var similarLimit = Math.max(1, asNumber(root.dataset.similarLimit) || 4);
    var allowedSearchTypes = normalizeTypeList(root.dataset.similarTypes);
    var trendQueries = normalizeLineList(root.dataset.trendQueries);
    var trendResultLimit = Math.max(1, asNumber(root.dataset.trendLimit) || 6);
    var trendAutoLoad = root.dataset.trendAutoLoad === "true";
    var trendRefreshSeconds = Math.max(0, asNumber(root.dataset.trendRefreshSeconds) || 300);

    var settingSelect = form.querySelector("[data-ring-setting]");
    var metalSelect = form.querySelector("[data-ring-metal]");
    var shapeSelect = form.querySelector("[data-ring-shape]");
    var caratSelect = form.querySelector("[data-ring-carat]");
    var sizeSelect = form.querySelector("[data-ring-size]");
    var engravingInput = form.querySelector("[data-ring-engraving]");
    var briefInput = form.querySelector("[data-ring-brief]");
    var attachmentInput = form.querySelector("[data-ring-attachment-url]");
    var priceNode = form.querySelector("[data-ring-price]");
    var variantInput = form.querySelector("input[name='id']");
    var demoSaveButton = form.querySelector("[data-ring-demo-save]");
    var demoOutput = form.querySelector("[data-ring-demo-output]");
    var demoJsonNode = form.querySelector("[data-ring-demo-json]");
    var matchPropertyInput = form.querySelector("[data-ring-match-property]");

    var matchQueryInput = form.querySelector("[data-ring-match-query]");
    var matchTrigger = form.querySelector("[data-ring-match-trigger]");
    var matchStatusNode = form.querySelector("[data-ring-match-status]");
    var matchResultsNode = form.querySelector("[data-ring-match-results]");
    var trendTagsNode = form.querySelector("[data-ring-trend-tags]");
    var trendStatusNode = form.querySelector("[data-ring-trend-status]");
    var trendResultsNode = form.querySelector("[data-ring-trend-results]");

    var contactForm = root.querySelector("form[id^='ring-request-form-']");
    var contactSummaryInput = root.querySelector("[data-ring-contact-summary]");
    var contactMatchesInput = root.querySelector("[data-ring-contact-matches]");
    var contactTrendingInput = root.querySelector("[data-ring-contact-trending]");
    var confirmRow = root.querySelector("[data-ring-confirm-row]");
    var confirmCustom = root.querySelector("[data-ring-confirm-custom]");
    var requestMessage = root.querySelector("[id^='ring-request-message-']");
    var requestAttachment = root.querySelector("[id^='ring-request-attachment-']");

    var summaryNodes = {
      setting: form.querySelector("[data-summary-setting]"),
      metal: form.querySelector("[data-summary-metal]"),
      shape: form.querySelector("[data-summary-shape]"),
      carat: form.querySelector("[data-summary-carat]"),
      size: form.querySelector("[data-summary-size]"),
      engraving: form.querySelector("[data-summary-engraving]"),
      brief: form.querySelector("[data-summary-brief]"),
      attachment: form.querySelector("[data-summary-attachment]"),
      matches: form.querySelector("[data-summary-matches]")
    };

    var previewPlaceholder = form.querySelector("[data-ring-preview-placeholder]");
    var previewImage = form.querySelector("[data-ring-preview-image]");

    var settingMap = buildMap(config.settings || []);
    var metalMap = buildMap(config.metals || []);
    var shapeMap = buildMap(config.shapes || []);
    var caratMap = buildMap(config.carats || []);
    var currentMatches = [];
    var currentTrendingMatches = [];
    var lastSearchText = "";
    var lastSearchController = null;
    var trendSearchController = null;
    var trendRefreshTimer = null;

    function getSelectedData() {
      return {
        setting: settingSelect.value,
        metal: metalSelect.value,
        shape: shapeSelect.value,
        carat: caratSelect.value,
        size: sizeSelect.value,
        engraving: engravingInput.value.trim(),
        brief: briefInput ? briefInput.value.trim() : "",
        attachment: attachmentInput ? attachmentInput.value.trim() : ""
      };
    }

    function getMatchTitles() {
      return currentMatches.map(function (item) {
        return item.title;
      });
    }

    function buildConfigurationSummary(data) {
      var lines = [
        "Setting: " + (settingMap[data.setting] ? settingMap[data.setting].label : "-"),
        "Metal: " + (metalMap[data.metal] ? metalMap[data.metal].label : "-"),
        "Stone shape: " + (shapeMap[data.shape] ? shapeMap[data.shape].label : "-"),
        "Carat: " + (caratMap[data.carat] ? caratMap[data.carat].label : "-"),
        "Ring size: " + (data.size || "-"),
        "Engraving: " + (data.engraving || "-"),
        "Design brief: " + (data.brief || "-"),
        "Inspiration attachment: " + (data.attachment || "-"),
        "Suggested matches: " + (getMatchTitles().join(", ") || "-")
      ];
      return lines.join("\n");
    }

    function updateSummary(data) {
      summaryNodes.setting.textContent = "Setting: " + (settingMap[data.setting] ? settingMap[data.setting].label : "-");
      summaryNodes.metal.textContent = "Metal: " + (metalMap[data.metal] ? metalMap[data.metal].label : "-");
      summaryNodes.shape.textContent = "Stone shape: " + (shapeMap[data.shape] ? shapeMap[data.shape].label : "-");
      summaryNodes.carat.textContent = "Carat: " + (caratMap[data.carat] ? caratMap[data.carat].label : "-");
      summaryNodes.size.textContent = "Ring size: " + (data.size || "-");
      summaryNodes.engraving.textContent = "Engraving: " + (data.engraving || "-");
      if (summaryNodes.brief) {
        summaryNodes.brief.textContent = "Design brief: " + (data.brief || "-");
      }
      if (summaryNodes.attachment) {
        summaryNodes.attachment.textContent = "Inspiration attachment: " + (data.attachment || "-");
      }
      if (summaryNodes.matches) {
        summaryNodes.matches.textContent = "Suggested matches: " + (getMatchTitles().join(", ") || "-");
      }
    }

    function calculatePrice(data) {
      var total = basePrice;

      total += asNumber(settingMap[data.setting] && settingMap[data.setting].priceDelta);
      total += asNumber(metalMap[data.metal] && metalMap[data.metal].priceDelta);
      total += asNumber(shapeMap[data.shape] && shapeMap[data.shape].priceDelta);
      total += asNumber(caratMap[data.carat] && caratMap[data.carat].priceDelta);

      if (data.engraving.length > 0) {
        total += engravingFee;
      }

      return total;
    }

    function updatePreviewImage(data) {
      var key = [data.setting, data.metal, data.shape].join("|");
      var imageUrl = previewImageMap[key];
      var fallback = buildRingSvg(data);

      previewImage.onerror = function () {
        previewImage.onerror = null;
        previewImage.src = fallback;
        previewImage.alt = "Ring preview";
      };

      previewImage.src = imageUrl || fallback;
      previewImage.alt = imageUrl ? "Ring preview for " + key : "Ring preview";
      previewImage.hidden = false;
      if (previewPlaceholder) {
        previewPlaceholder.hidden = true;
      }
    }

    function setMatchMessage(message, tone) {
      if (!matchStatusNode) {
        return;
      }
      matchStatusNode.textContent = message;
      matchStatusNode.hidden = !message;
      matchStatusNode.dataset.tone = tone || "neutral";
    }

    function updateMatchFields() {
      var titles = getMatchTitles();
      var serialized = titles.join(", ");
      if (matchPropertyInput) {
        matchPropertyInput.value = serialized;
      }
      if (contactMatchesInput) {
        contactMatchesInput.value = serialized;
      }
      if (contactTrendingInput) {
        contactTrendingInput.value = currentTrendingMatches
          .map(function (item) {
            return item.title;
          })
          .join(", ");
      }
      if (confirmRow && confirmCustom) {
        var hasMatches = titles.length > 0;
        confirmRow.hidden = !hasMatches;
        confirmCustom.required = hasMatches;
        if (!hasMatches) {
          confirmCustom.checked = false;
        }
      }
    }

    function renderMatchResults(matches, query) {
      if (!matchResultsNode) {
        return;
      }
      matchResultsNode.innerHTML = "";
      currentMatches = matches;
      updateMatchFields();

      if (!matches.length) {
        matchResultsNode.hidden = true;
        setMatchMessage("No close matches found. You can continue with a custom request.", "neutral");
        emitAnalyticsEvent(root, "ring_builder_inventory_match_none", { query: query });
        refresh();
        return;
      }

      matches.forEach(function (product) {
        var item = document.createElement("li");
        var link = document.createElement("a");
        var money = toMoneyFromCents(product.price, product.price_min_currency || product.price_currency);

        link.href = product.url;
        link.textContent = product.title + " - " + money;
        link.target = "_self";

        item.appendChild(link);
        if (product.product_type) {
          var typeText = document.createTextNode(" (" + product.product_type + ")");
          item.appendChild(typeText);
        }
        matchResultsNode.appendChild(item);
      });

      matchResultsNode.hidden = false;
      setMatchMessage(
        "We found " + matches.length + " similar product(s). Review them before submitting a custom request.",
        "warning"
      );
      emitAnalyticsEvent(root, "ring_builder_inventory_match_found", {
        query: query,
        count: matches.length,
        handles: matches.map(function (item) {
          return item.handle;
        })
      });
      refresh();
    }

    function setTrendMessage(message, tone) {
      if (!trendStatusNode) {
        return;
      }
      trendStatusNode.textContent = message;
      trendStatusNode.hidden = !message;
      trendStatusNode.dataset.tone = tone || "neutral";
    }

    function renderTrendResults(results) {
      if (!trendResultsNode) {
        return;
      }
      trendResultsNode.innerHTML = "";
      currentTrendingMatches = results;
      updateMatchFields();

      if (!results.length) {
        trendResultsNode.hidden = true;
        setTrendMessage("No trend-based matches found right now.", "neutral");
        return;
      }

      results.forEach(function (product) {
        var item = document.createElement("li");
        var link = document.createElement("a");
        var money = toMoneyFromCents(product.price, product.price_currency);
        var label = product.queryLabel ? "[" + product.queryLabel + "] " : "";
        link.href = product.url;
        link.textContent = label + product.title + " - " + money;
        link.target = "_self";
        item.appendChild(link);
        trendResultsNode.appendChild(item);
      });

      trendResultsNode.hidden = false;
      setTrendMessage("Trend matches refreshed from your inventory.", "success");
      emitAnalyticsEvent(root, "ring_builder_trend_results_loaded", {
        count: results.length,
        queries: trendQueries
      });
    }

    function productAllowed(product) {
      if (!allowedSearchTypes.length) {
        return true;
      }
      var type = String(product.product_type || "").trim().toLowerCase();
      return allowedSearchTypes.indexOf(type) > -1;
    }

    function mapSuggestProduct(raw) {
      return {
        title: raw.title || "Untitled",
        url: raw.url || "#",
        handle: raw.handle || "",
        product_type: raw.product_type || "",
        price: raw.price,
        price_currency: raw.price_currency
      };
    }

    function fetchSimilarProducts(query) {
      if (!query) {
        currentMatches = [];
        updateMatchFields();
        renderMatchResults([], query);
        return Promise.resolve([]);
      }
      if (lastSearchController) {
        lastSearchController.abort();
      }
      lastSearchController = new AbortController();
      setMatchMessage("Searching inventory...", "neutral");

      var endpoint = buildSuggestEndpoint(query, similarLimit);

      return fetch(endpoint, {
        method: "GET",
        headers: { Accept: "application/json" },
        signal: lastSearchController.signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Suggest API failed");
          }
          return response.json();
        })
        .then(function (payload) {
          var products = (((payload || {}).resources || {}).results || {}).products || [];
          return products
            .map(mapSuggestProduct)
            .filter(productAllowed)
            .slice(0, similarLimit);
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") {
            return [];
          }
          setMatchMessage("Unable to check inventory right now. You can still submit a custom request.", "error");
          return [];
        });
    }

    function fetchSuggestedProducts(query, limit, signal) {
      var endpoint = buildSuggestEndpoint(query, limit);

      return fetch(endpoint, {
        method: "GET",
        headers: { Accept: "application/json" },
        signal: signal
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Suggest API failed");
          }
          return response.json();
        })
        .then(function (payload) {
          var products = (((payload || {}).resources || {}).results || {}).products || [];
          return products.map(mapSuggestProduct).filter(productAllowed);
        });
    }

    function renderTrendTags() {
      if (!trendTagsNode) {
        return;
      }
      trendTagsNode.innerHTML = "";
      trendQueries.forEach(function (query) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "button button--secondary";
        button.textContent = query;
        button.setAttribute("data-ring-trend-query", query);
        trendTagsNode.appendChild(button);
      });
    }

    function refreshTrendMatches(focusQuery) {
      var activeQueries = focusQuery ? [focusQuery] : trendQueries.slice(0);
      if (!activeQueries.length) {
        renderTrendResults([]);
        return;
      }
      if (trendSearchController) {
        trendSearchController.abort();
      }
      trendSearchController = new AbortController();
      setTrendMessage("Refreshing trend suggestions...", "neutral");

      Promise.all(
        activeQueries.map(function (query) {
          return fetchSuggestedProducts(query, trendResultLimit, trendSearchController.signal)
            .then(function (products) {
              return products.map(function (product) {
                product.queryLabel = query;
                return product;
              });
            })
            .catch(function (error) {
              if (error && error.name === "AbortError") {
                return [];
              }
              return [];
            });
        })
      )
        .then(function (groups) {
          var dedupe = {};
          var merged = [];

          groups.forEach(function (group) {
            group.forEach(function (product) {
              if (dedupe[product.handle]) {
                return;
              }
              dedupe[product.handle] = true;
              merged.push(product);
            });
          });

          renderTrendResults(merged.slice(0, trendResultLimit));
        })
        .catch(function () {
          setTrendMessage("Trend refresh failed. You can still use custom search.", "error");
          renderTrendResults([]);
        });
    }

    function enforceCompatibility(data) {
      var selectedSetting = settingMap[data.setting];
      var allowedShapes = normalizeCsv(selectedSetting && selectedSetting.allowedShapes);
      var hasRules = allowedShapes.length > 0;

      Array.prototype.forEach.call(shapeSelect.options, function (option) {
        if (!option.value) {
          option.disabled = false;
          return;
        }

        var allowed = !hasRules || allowedShapes.indexOf(option.value) > -1;
        option.disabled = !allowed;
      });

      if (data.shape && hasRules && allowedShapes.indexOf(data.shape) === -1) {
        shapeSelect.value = "";
        emitAnalyticsEvent(root, "ring_builder_incompatible_selection", {
          invalidShape: data.shape,
          setting: data.setting
        });
      }
    }

    function refresh() {
      var data = getSelectedData();
      enforceCompatibility(data);

      // Re-read after compatibility resets.
      data = getSelectedData();
      updateSummary(data);
      updatePreviewImage(data);
      if (contactSummaryInput) {
        contactSummaryInput.value = buildConfigurationSummary(data);
      }

      var total = calculatePrice(data);
      priceNode.textContent = moneyFromNumber(total, moneyFormat);
    }

    function exportDemoConfiguration() {
      var data = getSelectedData();
      var payload = {
        configuration: data,
        estimatedPrice: calculatePrice(data),
        estimatedPriceFormatted: moneyFromNumber(calculatePrice(data), moneyFormat),
        suggestedMatches: getMatchTitles(),
        generatedAt: new Date().toISOString()
      };
      var json = JSON.stringify(payload, null, 2);

      if (demoJsonNode) {
        demoJsonNode.value = json;
      }
      if (demoOutput) {
        demoOutput.hidden = false;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(json).catch(function () {});
      }

      emitAnalyticsEvent(root, "ring_builder_demo_saved", payload);
    }

    form.addEventListener("change", function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) {
        return;
      }

      emitAnalyticsEvent(root, "ring_builder_option_selected", {
        field: target.name,
        value: target.value
      });

      var stepElement = target.closest("[data-step]");
      if (stepElement) {
        emitAnalyticsEvent(root, "ring_builder_step_changed", {
          step: stepElement.getAttribute("data-step"),
          value: target.value
        });
      }

      refresh();
    });

    form.addEventListener("input", function (event) {
      if (event.target === engravingInput) {
        refresh();
      }
      if (event.target === briefInput) {
        refresh();
      }
      if (event.target === attachmentInput) {
        if (requestAttachment && !requestAttachment.value) {
          requestAttachment.value = attachmentInput.value.trim();
        }
        refresh();
      }
    });

    form.addEventListener("submit", function (event) {
      var data = getSelectedData();

      if (!variantInput || !variantInput.value) {
        event.preventDefault();
        exportDemoConfiguration();
        return;
      }

      emitAnalyticsEvent(root, "ring_builder_add_to_cart", data);
    });

    if (matchTrigger && matchQueryInput) {
      matchTrigger.addEventListener("click", function () {
        var query = matchQueryInput.value.trim();
        lastSearchText = query;
        fetchSimilarProducts(query).then(function (matches) {
          renderMatchResults(matches, query);
        });
      });

      matchQueryInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          matchTrigger.click();
        }
      });
    }

    if (trendTagsNode) {
      trendTagsNode.addEventListener("click", function (event) {
        var target = event.target;
        if (!(target instanceof HTMLButtonElement)) {
          return;
        }
        var query = target.getAttribute("data-ring-trend-query") || "";
        if (!query) {
          return;
        }
        refreshTrendMatches(query);
      });
    }

    if (contactForm) {
      contactForm.addEventListener("submit", function (event) {
        if (confirmCustom && confirmCustom.required && !confirmCustom.checked) {
          event.preventDefault();
          setMatchMessage("Please review matched products or confirm you still need custom work.", "warning");
          return;
        }

        var data = getSelectedData();
        var summary = buildConfigurationSummary(data);
        if (contactSummaryInput) {
          contactSummaryInput.value = summary;
        }
        if (contactTrendingInput) {
          contactTrendingInput.value = currentTrendingMatches
            .map(function (item) {
              return item.title;
            })
            .join(", ");
        }
        if (requestAttachment && attachmentInput && !requestAttachment.value.trim()) {
          requestAttachment.value = attachmentInput.value.trim();
        }

        if (requestMessage) {
          var extra = "\n\n--- Builder summary ---\n" + summary;
          if (!requestMessage.value.trim()) {
            requestMessage.value = summary;
          } else {
            requestMessage.value = requestMessage.value + extra;
          }
        }

        emitAnalyticsEvent(root, "ring_builder_request_submitted", {
          searchText: lastSearchText,
          matchCount: currentMatches.length
        });
      });
    }

    if (demoSaveButton) {
      demoSaveButton.addEventListener("click", exportDemoConfiguration);
    }

    emitAnalyticsEvent(root, "ring_builder_viewed", {
      sectionId: root.id || null
    });

    renderTrendTags();
    if (trendAutoLoad) {
      refreshTrendMatches();
    }
    if (trendRefreshSeconds > 0) {
      trendRefreshTimer = window.setInterval(function () {
        refreshTrendMatches();
      }, trendRefreshSeconds * 1000);
    }

    refresh();
  }

  document.querySelectorAll("[data-ring-builder]").forEach(function (root) {
    initLiveStudio(root);
    initRingBuilder(root);
  });
})();
